import { useCallback, useEffect, useState } from 'react';
import { useLocale } from '../context';
import { hardReloadApp, resetReloadSchedule } from '../utils/assetCache';
import { APP_UPDATE_PROMPT_EVENT, touchAppActivity } from '../utils/idleReload';
import './AppUpdatePopup.css';

function RefreshIcon() {
  return (
    <svg
      className="app-update-popup__icon-svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      aria-hidden="true"
      focusable="false"
    >
      <path
        fill="currentColor"
        d="M17.65 6.35A7.95 7.95 0 0 0 12 4a8 8 0 1 0 7.75 10h-2.1A6 6 0 1 1 12 6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35Z"
      />
    </svg>
  );
}

export default function AppUpdatePopup() {
  const { t } = useLocale();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onPrompt = () => setOpen(true);
    window.addEventListener(APP_UPDATE_PROMPT_EVENT, onPrompt);
    return () => window.removeEventListener(APP_UPDATE_PROMPT_EVENT, onPrompt);
  }, []);

  const handleUpdate = useCallback(() => {
    touchAppActivity();
    setOpen(false);
    resetReloadSchedule();
    hardReloadApp({ reason: 'idle-update' });
  }, []);

  if (!open) return null;

  return (
    <div className="app-update-popup" role="status" aria-live="polite">
      <div className="app-update-popup__inner">
        <span className="app-update-popup__icon" aria-hidden="true">
          <RefreshIcon />
        </span>
        <div className="app-update-popup__info">
          <div className="app-update-popup__title">{t('appUpdate.title')}</div>
          <div className="app-update-popup__text">{t('appUpdate.text')}</div>
          <button type="button" className="app-update-popup__btn" onClick={handleUpdate}>
            {t('appUpdate.action')}
          </button>
        </div>
      </div>
    </div>
  );
}
